import { useRef } from 'react'

import { useScrollInteractionHandler } from './hooks/useScrollInteractionHandler'
import { useTouch } from './touch-context'

import { cn } from '@/shared/utils'

const WHITE_SRC = '/images/branding/glassis/glassis_sequence/glassis_text_white.png'
const DEFAULT_SRC = '/images/branding/glassis/glassis_sequence/glassis_text_default.png'

const Section3 = ({ containerRef }: { containerRef: React.RefObject<HTMLDivElement> }) => {
  const { isTouching } = useTouch()
  const whiteRef = useRef<HTMLImageElement>(null)
  const defaultRef = useRef<HTMLImageElement>(null)
  const sectionRef = useRef<HTMLElement>(null)

  const resetSrc = () => {
    if (whiteRef.current) {
      whiteRef.current.src = ''
      whiteRef.current.src = WHITE_SRC
    }
    if (defaultRef.current) {
      defaultRef.current.src = ''
      defaultRef.current.src = DEFAULT_SRC
    }
  }

  useScrollInteractionHandler({
    containerRef,
    sectionRef,
    onGoBack: () => {
      resetSrc()
    },
    onEnter: () => {
      resetSrc()
    },
  })
  return (
    <section ref={sectionRef} className="relative flex h-full items-center justify-center bg-transparent">
      <div className="absolute top-0 left-0 right-0 h-full w-full flex items-center justify-center pt-14">
        <img
          ref={whiteRef}
          src={WHITE_SRC}
          alt="glassis_to_logo_white"
          className={cn('h-full object-cover opacity-10', isTouching && 'z-50 opacity-100')}
        />
      </div>
      <div className="absolute top-0 left-0 right-0 h-full w-full flex items-center justify-center pt-14">
        <img
          ref={defaultRef}
          src={DEFAULT_SRC}
          alt="glassis_to_logo_default"
          className={cn('h-full object-cover opacity-10', !isTouching && 'z-50 opacity-100')}
        />
      </div>
    </section>
  )
}

export default Section3
